import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'tableReport',
    label: 'Table Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
